import { Job } from "../main/accountant/jobs-and-tasks/job.model";
import { User } from "../shared-data.service";

export enum RootFolders {
  ROOT_CLIENT_SHARED = "client",
  ROOT_STAFF_ONLY = "staff",
}

export type File = {
  conversation: number;
  created_date: string;
  description?: string | null;
  etag: string;
  ext: string;
  file: string;
  filename: string;
  folder: number;
  from_conversation: boolean;
  id: number;
  is_deleted: boolean;
  is_public: boolean;
  job?: Job | null;
  mime_type: string;
  modified_date: string;
  sent_by: User;
  shared: boolean;
  staff_only: boolean;
  tracked_item?: any;
  type: number;
  upload_date: string;
  url: string;
  user: User;
};

export type ChildFolder = {
  conversation: number;
  created_date: string;
  file_count: number;
  folder_count: number;
  id: number;
  is_deleted: boolean;
  modified_date: string;
  name: string;
  parent: number;
  shared: boolean;
  staff_only: boolean;
  uuid: string;
};

export type ParentFolder = {
  files: File[];
  folders: ChildFolder[];
  title: string;
  uuid: string;
};
